module.exports = __webpack_public_path__ + "img/apple-icon-76x76.2f456b9d.png";